export const convertYoutubeUrlToNoCookieYoutubeUrl = (url: string): string => {
	let finalUrl = url;

	let toParse = url;
	// URL parsing will fail if the protocol isn't set
	if (!toParse.startsWith("https://") && !toParse.startsWith("http://")) {
		toParse = "https://" + toParse;
	}

	try {
		const parsedUrl = new URL(toParse);
		let isYoutube = false;
		let videoId = null;
		let time = null;

		// YouTube doesn't use country specific TLDs (unlike Google) so this should be fine
		if (parsedUrl.hostname.includes("youtube.com") && parsedUrl.pathname === "/watch") {
			isYoutube = true;
			videoId = parsedUrl.searchParams.get("v");
			time = parsedUrl.searchParams.get("t");
			// remove the 's' from the end of the time (does not work with embedded videos)
			if (time) time = time.slice(0, -1);
		}
		// some YouTube urls are shortened
		// pathname always includes '/' so we remove it to check if path is empty
		if (parsedUrl.hostname.includes("youtu.be") && parsedUrl.pathname.slice(1)) {
			isYoutube = true;
			videoId = parsedUrl.pathname.slice(1);
			time = parsedUrl.searchParams.get("t");
		}

		if (isYoutube && videoId) {
			// rel=0 restricts related videos to videos from same channel, loop causes the video to auto-loop
			finalUrl = `https://www.youtube-nocookie.com/embed/${videoId}?loop=true&rel=0`;
			if (time) {
				finalUrl += `&start=${time}`;
			}
		}
	} catch (e) {
		console.error(e);
		// in case URL parsing fails, we just continue
		console.log(e);
		return url;
	}

	return finalUrl;
};

export const isYoutubeVideoUrl = (url: string): boolean => {
	try {
		let toParse = url;
		// URL parsing will fail without a protocol
		if (!url.startsWith("http://") && !url.startsWith("https://")) {
			toParse = "https://" + url;
		}

		const parsedUrl = new URL(toParse);
		// YouTube doesn't use country specific TLDs (unlike Google) so this should be fine
		return (
			(parsedUrl.hostname.includes("youtube.com") && parsedUrl.pathname === "/watch") ||
			(parsedUrl.hostname.includes("youtu.be") && parsedUrl.pathname.slice(1) !== "")
		);
	} catch {
		return false;
	}
};

export const isNoCookieYoutubeUrl = (url: string): boolean => {
	try {
		let toParse = url;
		// URL parsing will fail without a protocol
		if (!url.startsWith("http://") && !url.startsWith("https://")) {
			toParse = "https://" + url;
		}

		const parsedUrl = new URL(toParse);
		return parsedUrl.hostname.includes("youtube-nocookie.com");
	} catch {
		return false;
	}
};

/**
 * Validates if a URL is suitable for Locked Focus:
 * - Must start with http:// or https://
 * - Must include a full path (i.e., not just the domain root)
 * - Client-side router paths with hash fragments in slash-hash-slash pattern (/#/) are considered valid
 */
export function isLockedFocusCompatibleUrl(url?: string): boolean {
	if (!url) {
		return false;
	}

	try {
		const parsed = new URL(url);

		// Must use http or https
		if (!["http:", "https:"].includes(parsed.protocol)) {
			return false;
		}

		// Check for client-side router paths with hash fragments in slash-hash-slash pattern (/#/)
		if (parsed.hash.startsWith("#/")) {
			return true;
		}

		// Path must not be just "/" (i.e., root only)
		return parsed.pathname !== "/" && parsed.pathname.length > 1;
	} catch {
		// Invalid URL format
		return false;
	}
}
